// extracted by mini-css-extract-plugin
export default {"navLink":"NavButtonComponent_navLink__LQrRD"};